import { render, staticRenderFns } from "./containerBB.vue?vue&type=template&id=942e552a&scoped=true&"
import script from "./containerBB.vue?vue&type=script&lang=js&"
export * from "./containerBB.vue?vue&type=script&lang=js&"
import style0 from "./containerBB.vue?vue&type=style&index=0&id=942e552a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942e552a",
  null
  
)

export default component.exports